import React from 'react'

import { Checkbox } from 'antd'

/**
 * Configuration for bay table columns (Forties and Twenties)
 */
export const getBayColumns = (
  handleDelete,
  t,
  handleCheckboxChange,
  showFourtyFootOnly = false
) => [
  {
    dataIndex: 'bay',
    editable: true,
    title: t('admin.tableColumns.bay'),
    width: showFourtyFootOnly ? '30%' : '40%',
  },
  {
    dataIndex: 'hatchCovers',
    editable: true,
    title: t('admin.tableColumns.hatchCovers'),
    width: showFourtyFootOnly ? '25%' : '40%',
  },
  ...(showFourtyFootOnly
    ? [
        {
          dataIndex: 'fourtyFootOnly',
          render: (value, record) => (
            <Checkbox
              checked={value || false}
              onChange={e => handleCheckboxChange(record.key, e.target.checked)}
            />
          ),
          title: t('admin.tableColumns.fourtyFootOnly'),
          width: '25%',
        },
      ]
    : []),
  {
    dataIndex: 'action',
    render: (_, record) => (
      <a onClick={() => handleDelete(record.key)}>
        {t('admin.tableColumns.delete')}
      </a>
    ),
    title: '',
    width: '20%',
  },
]

/**
 * Configuration for main vessel table columns
 */
export const getVesselColumns = ({
  handleClone,
  handleExport,
  handleUpdate,
  t,
}) => [
  {
    dataIndex: 'vesselName',
    title: t('admin.tableColumns.vesselName'),
    width: '25%',
  },
  {
    dataIndex: 'vesselAbbreviation',
    render: (vesselAbbreviation, record) =>
      vesselAbbreviation || record.abbreviation || record.code || '',
    title: t('admin.tableColumns.vesselAbbreviation'),
    width: '15%',
  },
  {
    dataIndex: 'imoNumber',
    title: t('admin.tableColumns.imoNumber'),
    width: '15%',
  },
  {
    dataIndex: 'active',
    render: active => {
      const label = active ? t('admin.active') : t('admin.inactive')

      return (
        <span
          className={active ? 'admin-status-active' : 'admin-status-inactive'}
        >
          {label}
        </span>
      )
    },
    title: t('admin.status'),
    width: '10%',
  },
  {
    dataIndex: 'action',
    render: (_, record) => (
      <span className="admin-action-links">
        <a onClick={() => handleUpdate(record)}>
          {t('admin.tableColumns.edit')}
        </a>
        <span className="admin-action-separator">|</span>
        <a onClick={() => handleExport(record)}>
          {t('admin.tableColumns.export')}
        </a>
        <span className="admin-action-separator">|</span>
        <a onClick={() => handleClone(record)}>
          {t('admin.tableColumns.clone')}
        </a>
      </span>
    ),
    title: t('admin.tableColumns.action'),
    width: '35%',
  },
]

/**
 * Map columns with editable cell configuration
 */
export const mapEditableColumns = (columns, handleSave) =>
  columns.map(col => {
    if (!col.editable) {
      return col
    }

    return {
      ...col,
      onCell: record => ({
        dataIndex: col.dataIndex,
        editable: col.editable,
        handleSave,
        record,
        title: col.title,
      }),
    }
  })
